/** 註冊時寫入 auth user_metadata.reg_profile（公司） */
export interface CompanyRegProfile {
  kind?: string;
  companyName?: string;
  taxId?: string;
  businessLicense?: string;
  address?: string;
  website?: string;
  description?: string;
  specialties?: Array<number | string>;
  serviceAreas?: string[];
  service_areas?: string[];
}

export function parseCompanyRegProfile(
  metadata: Record<string, unknown> | null | undefined
): CompanyRegProfile | null {
  if (!metadata) return null;
  const raw = metadata.reg_profile;
  if (raw == null || raw === '') return null;
  try {
    const parsed =
      typeof raw === 'string' ? (JSON.parse(raw) as CompanyRegProfile) : (raw as CompanyRegProfile);
    if (!parsed || parsed.kind !== 'company') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function regProfileSpecialtyIds(profile: CompanyRegProfile): number[] {
  const raw = profile.specialties ?? [];
  const ids: number[] = [];
  for (const item of raw) {
    const n = typeof item === 'number' ? item : parseInt(String(item).replace(/\D/g, ''), 10);
    if (!Number.isNaN(n) && n > 0) ids.push(n);
  }
  return [...new Set(ids)];
}

export function regProfileServiceAreas(profile: CompanyRegProfile): string[] {
  const raw = profile.serviceAreas ?? profile.service_areas ?? [];
  return [...new Set(raw.map((a) => String(a).trim()).filter(Boolean))];
}

export function companyNeedsRegProfileSync(row: {
  specialties?: number[] | null;
  service_areas?: string[] | null;
}): boolean {
  const specs = row.specialties ?? [];
  const areas = row.service_areas ?? [];
  return specs.length === 0 || areas.length === 0;
}
